export const app = {
  grid: {
    noData: "Data tidak ditemukan",
    loading: "Silahkan tunggu sejenak ...",
    create: "Baru",
    search: "Cari ...",
  },
  discussion: {
    open: "Menunggu",
    closed: "Selesai",
    unreviewed: "Belum Dicek",
  },
  confirmation: {
    title: "Konfirmasi",
    yes: "Ya",
    no: "Batal",
  },
  notification: {
    position: "top-right",
    timeout: 2000,
  },
};

export default {
  namespaced: true,
  state: {
    ...app,
  },
  mutations: {},
  actions: {},
  getters: {},
};
